import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, TouchableWithoutFeedback, Keyboard } from 'react-native';
import SearchBar from './searchBar';
import SearchHistory from './searchHistory';
import Alert from '../alert';
import { pt, isWeb, isJDApp, isWX, isWQ, formatJumpUrl, jumpByUrl, sendClickDataWithJsonParam, sendExposureData, sendClickData, sendPv} from '../../../../components/utiles';
import { NAVIGATION_BAR_HEIGHT, SYS_BAR_HEIGHT } from '../../../../utils/steep';
import { 
	getZufangSearchHistoryList,
    deleZufangHistoryList
 } from '../../../../utils/api'

 const justLiulanqiHead = isWeb ? ((isJDApp || isWX || isWQ) ? 0 : pt(88)) : NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT

const styles = StyleSheet.create({
    body: {
        flex: 1,
        height: pt(750),
        backgroundColor: '#f6f6f6',
        alignItems: 'center',
        paddingTop: justLiulanqiHead
    },
    historyModal: {
    }
});
export default class Search extends PureComponent {
    static defaultProps = {
        keyword: '',
        cityName: '',
        cityId: '',
        placeholder: '',
        goSearchKeyword: () => {},
        isIconShow: false,
		back: () => {},
		searchPageViewStyle: {}
    }

    constructor(props) {
        super(props);
        this.state = {
            isShowAlert: false,
            historyList: [],
            isHistoryShow: true,
        };
        this.searchBarRef = React.createRef();
    }


    getSearchHistoryByPin = () => {
        getZufangSearchHistoryList({secondCode: this.props.cityId}).then(res => {
            const { code, searchContent } = res || {}
            if (code === 0 ) {
                this.setState({
                    historyList: searchContent || [],
                    isHistoryShow: (searchContent && searchContent.length !== 0) || false
                });
            }
           
        }).catch(err => {
            console.log(err);
            this.setState({
                historyList: [],
                isHistoryShow: false
            });
        });
    }
    componentDidMount() {
        this.getSearchHistoryByPin()
    }

    clearHistory = () => {
        sendClickDataWithJsonParam({
            event_id: 'OfficeBuilding_SearchList_ClearHistory',
            page_id: this.props.pageId,
        })
        this.setState({
            isShowAlert: true
        });
    }
    _goSearchKeyword = (keyword) => {
        this.props.goSearchKeyword(keyword)
    }
    onConfirm = () => {
        deleZufangHistoryList({}).then(res => {
            if (res && res.success) {
                this.setState({
                    isHistoryShow: false,
                    isShowAlert: false,
                    historyList: []
                });
            }
           
        }).catch(err => {
        });
    }

    onCancel = () => {
        this.setState({
            isShowAlert: false
        });
    }

    onBodyClick = () => {
        Keyboard && Keyboard.dismiss();
    }

    deletWordFocus= () => {
        this.searchBarRef && this.searchBarRef.current && this.searchBarRef.current.clearKeyword &&this.searchBarRef.current.clearKeyword()
    }

    render() {
        const { keyword, cityName, placeholder, beforeBack, pageId } = this.props;
        const { historyList, isHistoryShow,  isShowAlert } = this.state;
        return (
            <TouchableWithoutFeedback
                onPress={this.onBodyClick}
            >
                <View style={styles.body}>
                    <SearchBar
                        customStyle={{}}
                        ref={this.searchBarRef}
                        autoFocus={true}
                        cityName={cityName}
                        placeholder={placeholder}
                        keyword={keyword}
                        beforeBack={beforeBack}
                        search={this._goSearchKeyword}
                        handleFocus={() => {}}
                        pageId={pageId}
                    />
                    <View style={[styles.historyModal]}>
                        {isHistoryShow && <SearchHistory goHistorySearch={this._goSearchKeyword} clearHistory={this.clearHistory} historyList={historyList} pageId={pageId}/>}
                        
                    </View>
                    <Alert
                        title={'确定删除全部历史记录吗？'}
                        show={isShowAlert}
                        onConfirm={() => {
                            this.onConfirm();
                        }}
                        onCancel={() => {
                            this.onCancel();
                        }}
                    />
                </View>
            </TouchableWithoutFeedback>
        );
    }
}

Search.propTypes = {
    fromPage: PropTypes.string,
    pageId: PropTypes.string,
    isIconShow: PropTypes.bool,
    isAlwaysShow: PropTypes.bool,
    pageParam: PropTypes.string,
    configureType: PropTypes.string,
    getValue: PropTypes.func,
    customizeIsLenovoShow: PropTypes.bool,
    customizeSearchViewStyle: PropTypes.object,
    customizeModalViewStyle: PropTypes.object,
    customizeInputStyle: PropTypes.object,
    customizeSearchInputStyle: PropTypes.object,
    customizeStyle: PropTypes.object,
    customizeHotAndHistoryStyle: PropTypes.object,
    handleFocus: PropTypes.func,
    handleBlur: PropTypes.func,
    autoFocus: PropTypes.bool,
    cardStr: PropTypes.string,
    placeholder: PropTypes.string,
    back: PropTypes.func,
    customizeSearchInputViewStyle: PropTypes.object
};

Search.defaultProps = {
    fromPage: '',
    pageId: '',
    customizeIsLenovoShow: true,
    isIconShow: false,
    back: () => {},
    customizeSearchInputViewStyle: {},
    customizeModalViewStyle: {},
    cardStr: '',
    placeholder: '',
    customizeSearchViewStyle: {},
    customizeInputStyle: {},
    customizeSearchInputStyle: {},
    customizeStyle: {},
    isAlwaysShow: true,
    pageParam: '',
    configureType: '',
    getValue: () => {},
    customizeHotAndHistoryStyle: {},
    handleFocus: () => {},
    handleBlur: () => {},
    autoFocus: true
};
